import store from '@/stores'
import authService from '@/services/authService'

// Templates
import Page from '@/templates/Page'
import ResetPassword from '@/templates/ResetPassword'
import VerifyEmail from '@/templates/VerifyEmail'

import Login from '@/application/research/Login'
import Register from '@/application/research/Register'

import Dashboard from '@/application/research/Dashboard'
import YourKits from '@/application/research/YourKits'
import Surveys from '@/application/research/Surveys'

import Profile from '@/application/research/Profile'
import SurveysQuestions from '@/application/customer/SurveysQuestions'
import ReportSingle from '@/application/customer/ReportsSingle'
import Support from '@/application/research/Support'
import SendPage from '@/application/customer/Send'
import Consent from '@/application/research/ResearchConsent'
import EOI from '@/application/research/ResearchParticipantEOI'

const ifNotAuthenticated = (to, from, next) => {
  if (!authService.isLoggedIn()) {
    next()
    return
  }
  next('/dashboard')
}

const ifAuthenticated = (to, from, next) => {
  if (authService.isLoggedIn()) {
    // Ensure we have a user on every route
    if (store.state.GET_USER_RESPONSE === null) {
      store.dispatch('getUser')
    }
    // Ensure we have dashboard info on every route so we can check parental status
    const dashboard = store.state.GET_DASHBOARD_RESPONSE
    if (dashboard === null) {
      store.dispatch('getDashboard')
    } else if (dashboard && dashboard.profileCompleted === false && to.path !== '/profile') {
      console.log('No profile redirect')
      next('/profile')
      return
    }
    next()
    return
  }
  next('/login')
}

export default [
  {
    path: '/',
    redirect: '/dashboard',
    name: 'Home',
    component: Page,
    children: [
      {
        path: '/dashboard',
        name: 'Dashboard',
        component: Dashboard,
        beforeEnter: ifAuthenticated
      },
      {
        path: '/profile',
        name: 'Profile',
        component: Profile,
        beforeEnter: ifAuthenticated
      },
      {
        path: '/send',
        name: 'Send',
        component: SendPage,
        beforeEnter: ifAuthenticated
      },
      {
        path: '/kits',
        name: 'Your kits',
        component: YourKits,
        beforeEnter: ifAuthenticated
      },
      {
        path: '/reports',
        name: 'Reports',
        component: ReportSingle,
        beforeEnter: ifAuthenticated
      },
      {
        path: '/report/:reportId',
        name: 'Report',
        component: ReportSingle,
        beforeEnter: ifAuthenticated
      },
      {
        path: '/surveys',
        name: 'Surveys',
        component: Surveys,
        beforeEnter: ifAuthenticated
      },
      {
        path: 'surveys/:type/:kitId',
        name: 'Survey Single',
        component: SurveysQuestions,
        beforeEnter: ifAuthenticated
      },
      {
        path: 'support',
        name: 'Support',
        component: Support,
        beforeEnter: ifAuthenticated
      }
    ]
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    beforeEnter: ifNotAuthenticated
  },
  {
    path: '/register',
    name: 'Sign Up',
    component: Register,
    beforeEnter: ifNotAuthenticated
  },
  {
    path: '/reset-password',
    name: 'Reset password',
    component: ResetPassword,
    beforeEnter: ifNotAuthenticated
  },
  {
    path: '/recruitment/:recruitmentId/candidate/:candidateId/consent/:consentId',
    name: 'Consent',
    component: Consent
  },
  {
    path: '/recruitment/:recruitmentId/expression-of-interest',
    name: 'EOI',
    component: EOI,
    props: true
  },
  {
    path: '/verify-email',
    name: 'Verify email',
    component: VerifyEmail,
    beforeEnter: ifNotAuthenticated
  }
]



// WEBPACK FOOTER //
// ./src/router/research.js